import { render, staticRenderFns } from "./fee-lab-projecao-chart.vue?vue&type=template&id=577da9f3&scoped=true&"
import script from "./fee-lab-projecao-chart.vue?vue&type=script&lang=js&"
export * from "./fee-lab-projecao-chart.vue?vue&type=script&lang=js&"
import style0 from "./fee-lab-projecao-chart.vue?vue&type=style&index=0&id=577da9f3&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "577da9f3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('577da9f3')) {
      api.createRecord('577da9f3', component.options)
    } else {
      api.reload('577da9f3', component.options)
    }
    module.hot.accept("./fee-lab-projecao-chart.vue?vue&type=template&id=577da9f3&scoped=true&", function () {
      api.rerender('577da9f3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/fee-fixo/components/fee-lab-projecao-chart/fee-lab-projecao-chart.vue"
export default component.exports